// src/utils/axiosInstance.js

import axios from 'axios';
import { getToken, logout } from '../config/auth';

const API = axios.create({
  baseURL: 'http://3.110.167.23:8080/api',
});

// Add token to each request
API.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Catch expired token or unauthorized
API.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      logout(); // Clear localStorage and redirect
    }
    return Promise.reject(error);
  }
);

export default API;
